import React from 'react'
import Avatar from '../../avatar/Avatar'
import SkillsMenu from './SkillsMenu'

const Skills = () => {
  return (
    <>
      <Avatar page='skills' />
      <SkillsMenu />
    </>
  )
}

export default Skills
